import { getYear, subYears } from 'date-fns';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { QUERY_PARAM_VALUE } from '_constants/queryParams';
import { theme } from '_constants/theme';
import { createTaxReportsBody } from '_helpers/taxFilingInfo';
import { useConfirmInfoQueryParam } from '_hooks';
import { selectActivePersonalTaxFilingProduct } from '_store/order/selector';
import { selectActiveOrderId } from '_store/order/selector';
import { selectError, selectForm, selectLoading } from '_store/taxFilingInfo/selector';
import { updateTaxFilingInfo } from '_store/taxFilingInfo/slice';
import { selectCustomerId } from '_store/user/selector';

import Tabs from 'components/atomic/Tabs';
import Card from 'components/atomic/layouts/Card';
import Text from 'components/atomic/layouts/Text';
import DependentsForm from 'components/composed/forms/DependentsForm';
import FilingInfoForm from 'components/composed/forms/FilingInfoForm';
import PersonalInfoForm from 'components/composed/forms/PersonalInfoForm';

const FORMS = {
  [QUERY_PARAM_VALUE.personal]: PersonalInfoForm,
  [QUERY_PARAM_VALUE.dependents]: DependentsForm,
  [QUERY_PARAM_VALUE.filingInfo]: FilingInfoForm,
};

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledNavContainer = styled.div`
  margin-bottom: ${theme.spaces.regular}px;
`;

const TaxConfirmInfoView = () => {
  const [confirmInfoParamValue, setConfirmInfoParamValue] = useConfirmInfoQueryParam();
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);
  const orderId = useSelector(selectActiveOrderId);
  const form = useSelector(selectForm);
  const loading = useSelector(selectLoading);
  const error = useSelector(selectError);
  const personalTaxFilingProduct = useSelector(selectActivePersonalTaxFilingProduct);

  const handleSelectTab = (tabId) => {
    setConfirmInfoParamValue(tabId);
  };

  const handleSubmit = (values) => {
    if (values) {
      const { id: productId, taxReports: existingTaxReports } = personalTaxFilingProduct || {};
      const newTaxReports = createTaxReportsBody(values, existingTaxReports);
      const body = { ...personalTaxFilingProduct, taxReports: { ...existingTaxReports, ...newTaxReports } };
      dispatch(updateTaxFilingInfo({ customerId, orderId, productId, body }));
    }
  };

  const Form = FORMS[confirmInfoParamValue];

  return (
    <Card>
      <StyledHeader>
        <Text size={theme.fontSizes.medium} weight={600} bottomSpace={theme.spaces.large}>
          Confirm Your Information for {getYear(subYears(new Date(), 1))}
        </Text>
      </StyledHeader>
      <StyledNavContainer>
        <Tabs
          selected={confirmInfoParamValue}
          items={[
            {
              tabId: QUERY_PARAM_VALUE.personal,
              iconAlias: ICON_ALIASES.profileCircle,
              title: 'Personal',
            },
            {
              tabId: QUERY_PARAM_VALUE.dependents,
              iconAlias: ICON_ALIASES.users,
              title: 'Dependents',
            },
            {
              tabId: QUERY_PARAM_VALUE.filingInfo,
              iconAlias: ICON_ALIASES.documentNormal,
              title: 'Filing Info',
            },
          ]}
          onSelect={handleSelectTab}
        />
      </StyledNavContainer>
      {Form && (
        <Form error={error} loading={loading} submitDisabled={loading} defaultValues={form} onSubmit={handleSubmit} />
      )}
    </Card>
  );
};

export default TaxConfirmInfoView;
